import { useState } from 'react'
import { Box, Fab } from '@mui/material'
import { MdWhatsapp } from 'react-icons/md'
import { Clinica } from './data'
import { styles } from './styles'
import TelaHome from './TelaHome'
import TelaServico from './TelaServico'
import TelaDataHora from './TelaDataHora'
import TelaConfirmacao from './TelaConfirmacao'

const AgendamentoOnline = () => {
  const [tela, setTela] = useState('home')
  const [sessao, setSessao] = useState({
    servicoId: null,
    servicoNome: null,
    data: null,
    horario: null,
  })

  const avancarServico = (servico) => {
    setSessao((prev) => ({
      ...prev,
      servicoId: servico.id,
      servicoNome: servico.nome,
    }))
    setTela('data')
  }

  const avancarDataHora = (dataHora) => {
    setSessao((prev) => ({
      ...prev,
      data: dataHora.data,
      horario: dataHora.horario,
    }))
    setTela('confirmacao')
  }

  const voltar = () => {
    switch (tela) {
      case 'servico':
        setTela('home')
        break
      case 'data':
        setTela('servico')
        break
      case 'confirmacao':
        setTela('data')
        break
      default:
        break
    }
  }

  const reiniciar = () => {
    setSessao({
      servicoId: null,
      servicoNome: null,
      data: null,
      horario: null,
    })
    setTela('home')
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#e0e0e0',
        display: { md: 'flex' },
        justifyContent: { md: 'center' },
        alignItems: { md: 'center' },
      }}
    >
      <Box sx={styles.container}>
        {tela === 'home' && <TelaHome onAvancar={() => setTela('servico')} />}

        {tela === 'servico' && (
          <TelaServico onVoltar={voltar} onAvancar={avancarServico} />
        )}

        {tela === 'data' && (
          <TelaDataHora onVoltar={voltar} onAvancar={avancarDataHora} />
        )}

        {tela === 'confirmacao' && (
          <TelaConfirmacao
            dados={sessao}
            onVoltar={voltar}
            onReiniciar={reiniciar}
          />
        )}
      </Box>

      <Fab
        href={`https://wa.me/${Clinica.whatsapp}`}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          backgroundColor: '#25D366',
          color: 'white',
          '&:hover': { backgroundColor: '#1da851' },
        }}
      >
        <MdWhatsapp size={28} />
      </Fab>
    </Box>
  )
}

export default AgendamentoOnline
